import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { message, Spin } from "antd";
import JobForm from "Components/Form/JobForm";
import {
  useGetJobByIdQuery,
  useUpdateJobMutation,
} from "AppQuries/project/task";
import { jobCreationValidationSchema } from "core/Operations/ValidationSchema/projectValidationSchema";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
const EditTask = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const {
    data: jobData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetJobByIdQuery({
    companyCode: userData?.companyCode,
    locationCode: userData.selectedLocationCode,
    code: code,
  });

  const { mutate: updateTask, isError, error } = useUpdateJobMutation();

  const methods = useForm({
    defaultValues: {
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    },
    resolver: yupResolver(jobCreationValidationSchema),
  });

  const { setValue } = methods;

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  console.log("errors", errors);

  const onSubmit = (payload) => {
    const jobDetails = payload?.selectedEmployees?.map((emp) => ({
      id: 0,
      companyCode: userData?.companyCode,
      jobCode: "",
      employeeCode: emp,
      createUser: userData?.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
    }));

    delete payload.selectedEmployees;

    payload.jobsDetails = jobDetails;

    updateTask(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Task Updated Successfully.");
          // setTimeout(() => {
          navigate(`${all_routes.project}${all_routes.task_list}`);
          // }, 1000);
        } else {
          toast.danger("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.danger(error.message || "Something went wrong.");
      },
    });
  };

  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    if (Array.isArray(jobData) && jobData.length > 0) {
      Object.keys(jobData[0]).forEach((key) => {
        setValue(key, jobData[0][key]);
      });
      setValue(
        "selectedEmployees",
        jobData?.[0]?.jobsDetails?.map((d) => d.employeeCode)
      );
      setLoadingData(false);
    }
  }, [jobData]);
  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isSubmitting || loadingData) return <LoadingSpinner />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Edit Task</h4>
                    <h6>Edit your Task </h6>
                  </div>
                </div>

                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Update Task</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.project}${all_routes.task_list}`}
                      className="btn btn-secondary"
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Edit Task</h4>
                    </div>
                    <div className="card-body">
                      {loadingData ? (
                        <Spin size="large" tip="Loading..." spinning={true} />
                      ) : (
                        <JobForm mode="E" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditTask;
